import { render, staticRenderFns } from "./QualityTestingGGList.vue?vue&type=template&id=95b56a60&scoped=true"
import script from "./QualityTestingGGList.vue?vue&type=script&lang=js"
export * from "./QualityTestingGGList.vue?vue&type=script&lang=js"
import style0 from "./QualityTestingGGList.vue?vue&type=style&index=0&id=95b56a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b56a60",
  null
  
)

export default component.exports